import { Injectable } from '@angular/core';
import { HTTPService } from "../../shared/services/http.service"
import { DacConfig } from "../../shared/services/dac-config.service";

import {Assessment} from "../../shared/models/assessment"
import {AssessmentGroup} from "../../shared/models/assessment-group";

@Injectable()
export class AssessmentGroupService
{
    constructor(
        private http:HTTPService
    ) {

    }

    public createNewGroup(name:string) : Promise<AssessmentGroup> {
        return this.http.post("/assessment-groups/", {name: name}).then((response:any) => {
            let json = response.json() as AssessmentGroup;
            let group = new AssessmentGroup();
            Object.assign(group, json);
            return group;
        });
    }

    public updateAssessmentsForGroup(group:AssessmentGroup) : Promise<AssessmentGroup> {
        return this.http.post("/assessment-groups/" + group.Id + "/assessments/update", {})
            .then((response:any) => {
                let json = response.json() as AssessmentGroup;
                let group = new AssessmentGroup();
                Object.assign(group, json);
                return group;
            }
        );
    }

    /**
     * Persists the assessment in the group and returns the assessment with it's current id and version.
     * Since the assessments are versioned we add the UID of the assessment instead of its id which is why
     * we pass back the most current assessment as part of the add.
     */
    public addAssessmentToGroup(group:AssessmentGroup, assessment:Assessment) : Promise<Assessment> {
        if (!(assessment.uid && group.Id)) {
            return new Promise((resolve, reject) => {
                reject("assessment uid or group id was null, cannot add");
            });
        }

        let data = {
            uid: assessment.uid
        };
        return this.http.post("/assessment-groups/" + group.Id + "/assessments/", data).then((result:any) => {
            let newAssessment = new Assessment();
            Object.assign(newAssessment, assessment);
            newAssessment.version = 1;
            newAssessment.id = "12345"; // TODO: stephen where does this come from?
            return newAssessment;
        });
    }

    /**
     * Retrieves the groups from the server.  If the showAllGroups flag is set it will return
     * all the groups across host sites and companies.
     * @param showAllGroups true
     */
    public getAssessmentGroups(showAllGroups?:boolean) : Promise<AssessmentGroup[]> {
        let data:{showAllGroups?:boolean} = {};
        if (showAllGroups == true) {
            data.showAllGroups = true;
        }
        return this.http.get("/assessment-groups.json", data).then((response:any) => {
            let json = response.json() as any;
            let groups:AssessmentGroup[] = [];
            json as AssessmentGroup[];
            json.forEach((r) => {
                let group = new AssessmentGroup();
                Object.assign(group, r);
                group.Assessments = [];
                r.assessments.forEach((a) => {
                    let assessment = new Assessment();
                    Object.assign(assessment, a);
                    group.Assessments.push(assessment);
                });
                groups.push(group);
            });
            return groups;
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/services/assessment-group.service.ts